export default __webpack_public_path__ + "static/media/PPI-walkway-004.d261b213.jpg";